import { firestoreAction } from 'vuexfire'
import db from '../firebase'

const state = {
  feelingsFetched: false,
  feelings:[],
  feeling: null,
}
const getters = {
  feelings: (state) => {
    return state.feelings
  },
  feeling: (state) => {
    return state.feeling
  },
 
  feelingsFetched: (state) => {
    return state.feelingsFetched
  },

}
const mutations={
  logout_feelings(state){
    state.feelings=[];
    state.feelingsFetched=false;
      },

      remove_(state, ID){
        // let Index= state.violations.find(map => map.id ==Violation.id);
            let feelings= state.feelings;
            feelings.splice(ID, 1);
            state.feelings= feelings; 
              } 

}
const actions = {

  logoutFeelings ({commit}) {
    commit('logout_feelings')
},

  removeFeeling({commit},feelingID){
    
  commit("remove_", feelingID);
    db.collection('feeling').doc(feelingID).delete()
  },
  saveFeeling({},extra){
    extra.uploadDate=  Date.now() 
    db.collection('feeling').doc(extra.id).update(extra)
  },


  getFeeling({state},Code){
    db.collection('feeling').where('code', '==', Code).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        const id = doc.id
        const output = doc.data()
        output.id=id;
        state.feeling=output;
      })
    })
  },

  updateFeeling({},extra){

    db.collection('feeling').doc(extra.id).update(extra)
  },
  createFeeling({state},extra){
    let p = ""
      for (let i = 0; i <= 5; i++) {
        let element = Math.floor(Math.random() * 9+1); 
        p += element.toString();
      }
      extra.code= p ;
    extra.uploadDate=  Date.now() 
    //console.log(extra)
    db.collection('feeling').add(
      extra
    ).then(function(docRef) {
      extra.id=docRef.id
      state.feelings.push(extra)
  })
  
      },

//Classes

initFeelings({state},Id){
  //  (Cl)
  let cases=[];
  let query = db.collection('feeling')
  query = query.where('schoolId', '==', Id)

// query= query.where("class", "in", Id.classes); 
query.get().then(function (querySnapshot) {
  
    querySnapshot.forEach(function (doc) {
              const id = doc.id
              const data = doc.data()
        data.id=id;
              cases.push(data)
            })
                state.feelingsFetched=true;
            state.feelings= cases
          })
         
    },

    initFeelingsforMe({state},Id){
      //  (Cl)
      let cases=[];
      let query = db.collection('feeling')
      query = query.where('schoolId', '==', Id.schoolId)//.where('reciever', 'array-contains', Id.member)
    // query= query.where("class", "in", Id.classes); 
    query.get().then(function (querySnapshot) {
      
        querySnapshot.forEach(function (doc) {
                  const id = doc.id
                  const data = doc.data()
            data.id=id;
                  cases.push(data)
                })
                    state.feelingsFetched=true;
                state.feelings= cases
              })
             
        },

}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
